import { useSelector } from 'react-redux'
import props from '../../../../redux/props'
import { Survey } from '../../../../types/Survey/Survey'

type Props = {
  survey: Survey
}

const TimeLimitReached: React.FC<Props> = ({ survey }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  return (
    <div className="min-h-[60vh] flex flex-col gap-5 items-center justify-center">
      <div>
        <div className="font-bold text-xl md:text-2xl text-center whitespace-pre-wrap">
          {!!survey.context?.surveyTimeLimitReachedHeadline
            ? survey.context?.surveyTimeLimitReachedHeadline
            : t.survey.answer.timeLimitReached.headline}
        </div>
        <div className="text-center text-lg md:text-xl whitespace-pre-wrap">
          {!!survey.context?.surveyTimeLimitReachedText ? survey.context?.surveyTimeLimitReachedText : t.survey.answer.timeLimitReached.text}
        </div>
      </div>
    </div>
  )
}

export default TimeLimitReached
